<template>
  <div id="app">
    <!-- <div>{{lintResults}}</div> -->
    <Scoreboard :nodeId="nodeId" :challenges="nodeIds" :teams="teams" />

    <!-- Naming Challenge -->

    <div class="results" v-if="currentChallenge == 1">
      <h1 id="naming">Antworten</h1>

      <fieldset style="margin-top: 4rem">
        <p>Hier folgt etwas UI, wie es aus dem Browser kommt: 😢</p>
        <button @click="fetchFigmaDocumentData">Tabelle aktualisieren</button>
        <input type="password" placeholder="Password" v-model="password" />
        <label>
          <input type="checkbox" v-model="showAnswers" />
          <span>Antworten zeigen</span>
        </label>
      </fieldset>

      <table v-if="challengeNaming" style="margin-top: 4rem">
        <thead>
          <tr>
            <th>#</th>
            <th v-for="(file, i) in teams">{{ file.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(team, index) in challengeNaming[0]">
            <td>{{ index + 1 }}</td>
            <td v-for="(t, i) in teams">
              <template v-if="showAnswers && password == expected">{{
                challengeNaming[i][index] != "Hier Antwort eingeben" ? challengeNaming[i][index] : "—"
              }}</template>
              <template v-else>{{ challengeNaming[i][index] != "Hier Antwort eingeben" ? "✅" : "—" }}</template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Scoreboard from "./components/Scoreboard.vue";
import { mapState } from "vuex";

import teams from "./teams.js";

export default {
  components: {
    Scoreboard
  },
  methods: {
    fetchFigmaDocumentData() {
      this.teams.forEach((file) => {
        let parts = file.url.split("%2F");
        let key = parts[parts.length - 2];
        console.log(key);
        fetch(this.url + key, {
          type: "GET",
          headers: {
            "X-FIGMA-TOKEN": "40316-572b0bf7-9d6c-4eab-a290-4079525a1348"
          }
        }).then((response) => {
          response.json().then((result) => {
            file.data = result;
            this.nodeIds = [getArtboard(file.data, "Start").id, getArtboard(file.data, "Challenge #1").id];
            let fill = getLayer(file.data, "Start", "Team Color").fills[0].color;
            file.color = `rgba(${fill.r * 255}, ${fill.g * 255}, ${fill.b * 255}, 1)`;
            if (this.nodeIds) this.nodeId = this.nodeIds[0];
          });
        });
      });
    }
  },
  data: function() {
    return {
      password: "",
      expected: "we love typography",
      showAnswers: false,
      nodeId: "982%253A52",
      nodeIds: [],
      teams: [],
      rules: [
        {
          artboard: "SBB App",
          layer: "menu icon",
          property: "fontSize",
          path: "style",
          value: 24
        },
        {
          artboard: "SBB App",
          layer: "menu icon",
          property: "characters",
          value: "menu"
        }
      ],
      url: "https://api.figma.com/v1/files/"
    };
  },
  computed: {
    ...mapState({
      currentChallenge: (state) => state.currentChallenge,
      running: (state) => state.running,
      selected: (state) => state.selected,
      nodeIdPrefix: (state) => state.nodeIdPrefix
    }),
    challengeNaming() {
      if (this.teams && this.teams[0].data)
        return this.teams.map((file) => {
          if (file.data) {
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22].map((layer) => {
              let result = getLayer(file.data, "Challenge #1", "Antwort " + layer);
              return result ? result.characters : "";
            });
          }
        });
    },
    lintResults() {
      if (this.teams[0].data)
        return this.teams.map((file) => {
          if (file.data) {
            return this.rules.map((rule) => {
              var layer = getLayer(file.data, rule.artboard, rule.layer);
              let property = rule.path ? layer[rule.path][rule.property] : layer[rule.property];
              return {
                name: rule.layer,
                pass: property == rule.value ? "✅" : "❌"
              };
            });
          }
        });
    }
  },

  mounted: function() {
    teams.forEach((team) => {
      let url = team.url.replace(
        `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="`,
        ""
      );
      let index = url.indexOf("%3F");
      url = url.substr(0, index);

      this.teams.push({
        name: team.name,
        url: url,
        score: "1",
        color: "black",
        data: null,
        members: team.members
      });
    });

    this.fetchFigmaDocumentData();
  }
};

function getLayer(file, artboardName, layerName) {
  if (file && file.document && file.document.children.length) {
    let artboards = file.document.children[0].children;
    let artboard = artboards.find((a) => a.name == artboardName);
    if (artboard) {
      let layer = artboard.children.find((layer) => layer.name == layerName);
      return layer;
    }
  }
}

function getArtboard(file, artboardName) {
  if (file) {
    let artboards = file.document.children[0].children;
    let artboard = artboards.find((a) => a.name == artboardName);
    return artboard;
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: "Avenir Next", sans-serif;
  padding-bottom: 4rem;
  margin-bottom: 4rem;
}

table {
  border-collapse: collapse;
}
th {
  text-align: left;
  padding: 1rem;
  border-bottom: 1px solid #000;
}
tr td {
  border-bottom: 1px solid #000;
  padding: 1rem;
}
table {
  width: 100%;
}
td {
  white-space: nowrap;
  width: calc(100% / 9);
}
.results {
  padding: 5%;
  margin-top: 8rem;
}
</style>
